var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports,"__esModule",{value:true});exports.i18nOptions=void 0;
var _en=_interopRequireDefault(require("@24i/prd-localization-files-prj-telegram/dist/en.json"));
var _pt=_interopRequireDefault(require("@24i/prd-localization-files-prj-telegram/dist/pt.json"));
var _es=_interopRequireDefault(require("@24i/prd-localization-files-prj-telegram/dist/es.json"));
var _bo=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/bo.json"));
var _th=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/th.json"));
var _tr=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/tr.json"));
var _ps=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/ps.json"));
var _prs=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/prs.json"));
var _my=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/my.json"));
var _uk=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/uk.json"));
var _id=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/id.json"));
var _ur=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/ur.json"));
var _ko=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/ko.json"));
var _fa=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/fa.json"));
var _zh=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/zh.json"));
var _ru=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/ru.json"));
var _fr=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/fr.json"));
var _vi=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/vi.json"));
var _sw=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/sw.json"));
var _pbt=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/pbt.json"));

var i18nOptions={
resources:{
en:{sott:_en.default},
pt:{sott:_pt.default},
bo:{sott:_bo.default},
th:{sott:_th.default},
tr:{sott:_tr.default},
ps:{sott:_ps.default},
prs:{sott:_prs.default},
my:{sott:_my.default},
uk:{sott:_uk.default},
id:{sott:_id.default},
ur:{sott:_ur.default},
ko:{sott:_ko.default},
fa:{sott:_fa.default},
zh:{sott:_zh.default},
es:{sott:_es.default},
ru:{sott:_ru.default},
fr:{sott:_fr.default},
sw:{sott:_sw.default},
vi:{sott:_vi.default},
pbt:{sott:_pbt.default}
}
};exports.i18nOptions=i18nOptions;